import {Trans} from '@lingui/macro';
import React, {FC, useEffect} from 'react';

import {getParameters} from '../../../editors/expressions/expressionInferHelpers';
import {useExpressionsContext} from '../../../editors/expressions/expressionsContext';
import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import type {AtomCardProps} from './atomCard';
import {AtomIcon} from './atomIcon';
import {AtomTitle} from './atomTitle';
import {AtomParameterPicker} from './pickers/atomParameterPicker';

/*
 * Component.
 */

export const PreviousAtomCard: FC<AtomCardProps> = (props) => {
  const {atom, isDisabled, onUpdateAtom, onCancel} = props;
  const [expressionParam] = getParameters(atom);
  const {expressions} = useExpressionsContext();

  useEffect(() => {
    const expressionId = atom.params.expression;
    const firstExpression = expressions[0];

    // Auto-select first expression.
    if (!expressionId && firstExpression) {
      onUpdateAtom({
        ...atom,
        params: {
          expression: firstExpression.id,
        },
      });
    }
  }, [atom, expressions, onUpdateAtom]);

  const title = (
    <AtomTitle atom={atom} title={<Trans id="rule-expressions-usevalueof">Use value of</Trans>}>
      <AtomParameterPicker
        parameter={expressionParam}
        atom={atom}
        isDisabled={isDisabled}
        onUpdate={onUpdateAtom}
      />
    </AtomTitle>
  );

  return (
    <RuleMultilineParameterCard
      errorMessage={atom.errorMessage}
      title={title}
      icon={<AtomIcon atom={atom} />}
      onCancel={onCancel}
    />
  );
};
